import { put, select } from 'redux-saga/effects'
import _ from 'lodash'

import { createNewGroup, loadGroupMembers, setupGroupStack } from '../actions'

import { groupStackSelector } from '../selectors'

import { NEW_GROUP, CLOSE_GROUP_STACK } from '../constants'

export default function* toggleGroupStackSaga(action) {
    const groupId = _.get(action, 'data.groupId', null)
    const { activeGroup } = yield select(groupStackSelector)

    if (groupId === NEW_GROUP) {
        yield put(createNewGroup(groupId))

        return null
    }

    if (groupId === CLOSE_GROUP_STACK || groupId === activeGroup) {
        yield put(setupGroupStack(null))

        return null
    }

    yield put(setupGroupStack(groupId, { loading: true }))
    yield put(loadGroupMembers(groupId, 0))

    return null
}
